import { render, staticRenderFns } from "./EventsHome.vue?vue&type=template&id=5f3d6f2c&scoped=true&"
import script from "./EventsHome.vue?vue&type=script&lang=js&"
export * from "./EventsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d6f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3d6f2c')) {
      api.createRecord('5f3d6f2c', component.options)
    } else {
      api.reload('5f3d6f2c', component.options)
    }
    module.hot.accept("./EventsHome.vue?vue&type=template&id=5f3d6f2c&scoped=true&", function () {
      api.rerender('5f3d6f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/EventsHome.vue"
export default component.exports